import React, { useMemo } from 'react';

import { Flex, HStack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';

import { Icon } from 'components';
import { ContentRoutes } from 'enums/routes';

export default function ChecklistItem({ index, style, data }) {
  const item = useMemo(() => data[index], [index, data]);

  const { push } = useHistory();
  return (
    <Flex
      p={2}
      cursor="pointer"
      onClick={() => push(`/${ContentRoutes.Checklists}/${item.checklist.id}/${item.id}`)}
      style={style}>
      <Flex
        borderRadius={8}
        px={6}
        py={4}
        width="100%"
        height="56px"
        bg="white.default">
        <Flex
          alignItems="center"
          width="100%"
          justifyContent="space-between">
          <HStack>
            <Icon
              name="check"
              color="system.success.default"
            />
            <Text
              color="gray.600"
              variant="mediumBold">Check-list {item.checklist.type}
            </Text>
            <Text variant="xSmallRegular">
              Condutor: {item.driver.name}
            </Text>
          </HStack>
          <Text variant="xSmallRegular">
            Execução: {dayjs(item.updatedAt).format('DD/MM/YYYY')}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
